// extracted by mini-css-extract-plugin
export default {"projectsContainer":"Wells_projectsContainer__A7NEC"};